import { computed } from "vue";
import { settingStore } from "../store/settingStore";
import { store } from '../../store';

export const windowContentScaleX = computed( () => {
    return settingStore.isFixed == 0 ? store.contentScale : store.contentScaleX;
})

export const windowContentScaleY = computed( () => {
    return settingStore.isFixed == 0 ? store.contentScale : store.contentScaleY;
})